import { render, staticRenderFns } from "./SelectItemAssetPreview.vue?vue&type=template&id=1bb2cd3f&scoped=true"
import script from "./SelectItemAssetPreview.vue?vue&type=script&lang=js"
export * from "./SelectItemAssetPreview.vue?vue&type=script&lang=js"
import style0 from "./SelectItemAssetPreview.vue?vue&type=style&index=0&id=1bb2cd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2cd3f",
  null
  
)

export default component.exports